import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * TeamPhoto Schema
 * A photo in a DivisionTeam's mobile gallery, stored in Spaces. `url` is the
 * S3 Location returned at upload (non-CDN origin host — CDN rewrite is a
 * later optimization). Uploaded by members; deletable by the uploader or an
 * admin (soft delete).
 */
export const TeamPhotoSchema = z.object({
  _id: objectId,
  divisionTeam: objectId,
  organization: objectId.optional(),
  uploader: objectId,
  url: z.string().min(1),
  caption: z.string().max(200).optional(),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  ...timestampFields,
});

export type TeamPhoto = z.infer<typeof TeamPhotoSchema>;

export const teamPhotoMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  divisionTeam: { ref: 'DivisionTeam', label: 'Team' },
  organization: { ref: 'Organization', label: 'Organization' },
  uploader: { ref: 'User', label: 'Uploader' },
  url: { label: 'URL' },
  caption: { label: 'Caption' },
  width: { label: 'Width' },
  height: { label: 'Height' },
  created: { hidden: true },
  updated: { hidden: true },
};
